<style src="./QuoteMap.scss" lang="scss" scoped></style>
<template>
  <section
    class="quote-map"
    v-shortkey="{
      'nextitem': ['alt', 'arrowright'],
      'previtem': ['alt', 'arrowleft'],
      'jumpup': ['alt', 'arrowup'],
      'jumpdown': ['alt', 'arrowdown']}"
    @shortkey="goToItem">
    <span class="title">MAPA DOS ITENS</span>
    <ul class="map-container"
      v-for="(mappedItem, mappedIdx) in mappedItemList"
      :key="mappedIdx">
      <span
        class="lot-title"
        v-if="mappedItem[0].lot !== 'N'">
        LOTE {{ mappedItem[0].lot }}
      </span>

      <li
        v-for="(item, itemIdx) in mappedItem"
        :key="itemIdx"
        :class="{
          'item__stricttoquote': item.strictToME,
          'item__unquoted': item.status === 0,
          'item__quoted': item.status === 1,
          'item__alert': item.message && item.message.length > 0,
          'item__focus-me': item.id === getSelectedItem}"
        @click="selectItemToQuote(item.id)">

        <!-- <div class="user-avatar" v-show="item.shareItem"></div> -->
        {{ item.number }}
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuoteMap',
  data () {
    return {
      mappedItemList: null,
      sharingMap: []
    }
  },
  sockets: {
    'map-share-user' (pShareUser) {
      const eventId = this.$store.getters['Events/GET_EVENT_DETAILS']
      const userId = this.$store.getters['Login/GET_USER_ID']
      if (pShareUser.eventId !== eventId._id || pShareUser.userId === userId) return false

      const privateSharingMap = JSON.parse(JSON.stringify(this.sharingMap))
      for (let item in privateSharingMap) {
        if (privateSharingMap[item].userId === pShareUser.userId) {
          privateSharingMap.splice(item, 1)
        }
      }
      privateSharingMap.push(pShareUser)
      this.sharingMap = privateSharingMap
    }
  },
  computed: {
    ...mapGetters({
      getMappedList: 'ItemAssociation/GET_MAPPED_LIST',
      getAllList: 'ItemAssociation/GET_ALL_LIST',
      getSelectedItem: 'ItemAssociation/GET_ITEM_SELECTED_ID'
    })
  },
  watch: {
    getMappedList (pMapped) {
      this.mappedItemList = this.createLotedMap(pMapped)
    },
    getSelectedItem (itemId) {},
    sharingMap (pMap) {
      for (let theLot in this.mappedItemList) {
        for (let theItem in this.mappedItemList[theLot]) {
          const includeYes = pMap.findIndex((elm, idx, arr) => {
            return elm.itemId === this.mappedItemList[theLot][theItem].id
          })
          if (includeYes > -1) {
            this.mappedItemList[theLot][theItem].shareItem = true
          } else {
            this.mappedItemList[theLot][theItem].shareItem = false
          }
        }
      }
    }
  },
  methods: {
    createLotedMap (pMap) {
      const groupedMap = this.groupedMap(pMap)
      return groupedMap
    },
    groupedMap (pMap) {
      let group = {}
      pMap.map((item) => {
        if (!group[`lot${item.lot}`]) group[`lot${item.lot}`] = []
        group[`lot${item.lot}`].push(item)
      })
      return group
    },
    selectItemToQuote (pIndex) {
      const itemSelected = this.getAllList.find((item) => item._id === pIndex)
      this.$store.commit('ItemAssociation/SET_SELECTED_ITEM', { itemDetail: itemSelected })
    },
    goToItem (event) {
      let nav = 0
      switch (event.srcKey) {
        case 'nextitem':
          nav = 1
          break
        case 'previtem':
          nav = -1
          break
        case 'jumpdown':
          nav = 6
          break
        case 'jumpup':
          nav = -6
          break
        default:
          nav = 1
      }
      this.$store.dispatch('ItemAssociation/NAVIGATE_MAP', nav)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-association/components/quote-map/QuoteMap.vue